import React, { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { Form, Formik } from "formik";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";
import {
  Backdrop,
  Box,
  Chip,
  Drawer,
  FormControl,
  FormLabel,
  InputAdornment,
  TextField,
} from "@mui/material";
import { HalfInputWrapper, LabelStyle } from "../../Common/styles/form";
import { useParams } from "react-router-dom";
import { commonContainerWrapper } from "../../Common/styles/flex";
import { DrawerForm } from "../../Common/styles/drawer";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Loader from "../../Common/assets/Loader";
import AddLanguagesDrawer from "../../StudySettings/Tabs/AddLanguagesDrawer";

type Props = {
  canEdit: boolean;
};
const Languages = ({ canEdit }: Props) => {
  const { id: studyId } = useParams();
  const [loading, setLoading] = useState(false);
  const [languages, setLanguages] = useState<any[]>([]);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [toggleLoader, setToggleLoader] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let url = `/admin/registry/settings/languages`;
        const res: AxiosResponse = await http.get(url);
        const resData = res?.data?.data;
        const languageOptions = resData.map((lang: any) => ({
          languageCode: lang.languageCode,
          languageLabel: lang.languageLabel,
        }));

        setLanguages(languageOptions || []);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        errorToastMessage(err as Error);
      }
    };
    fetchData();
  }, [toggleLoader, setLoading, studyId]);

  function refreshPage() {
    setToggleLoader((prev: boolean) => !prev);
  }

  const closeDrawer = () => {
    setOpenDrawer(false);
  };

  return (
    <>
      {loading ? (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      ) : (
        <Box sx={commonContainerWrapper}>
          <Formik
            initialValues={{
              displayLanguages: languages?.length > 0 ? languages : [],
            }}
            onSubmit={(values) => {}}
          >
            {({ values }: any) => (
              <Form style={DrawerForm}>
                <Box>
                  <FormControl sx={{ ...HalfInputWrapper, mb: 2 }}>
                    <FormLabel sx={LabelStyle} htmlFor="languages">
                      Languages
                    </FormLabel>

                    <TextField
                      id="languages"
                      value=""
                      placeholder="Select Languages"
                      onClick={(event) => {
                        event.stopPropagation();
                        setOpenDrawer(true);
                      }}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            sx={{ cursor: "pointer" }}
                          >
                            <ExpandMoreIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ input: { cursor: "pointer" } }}
                    />
                  </FormControl>
                  {values?.displayLanguages?.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        mr: 2,
                        mb: 3,
                        flexWrap: "wrap",
                      }}
                    >
                      {values?.displayLanguages?.map((lang: any) => (
                        <Chip
                          sx={{
                            borderRadius: 1,
                            backgroundColor: "secondary.main",
                          }}
                          key={lang?.languageCode}
                          label={lang?.languageLabel}
                        />
                      ))}
                    </Box>
                  )}
                </Box>
              </Form>
            )}
          </Formik>
          <Drawer open={openDrawer} onClose={closeDrawer} anchor={"right"}>
            <AddLanguagesDrawer
              closeDrawer={closeDrawer}
              refreshPage={refreshPage}
              selectedLanguages={languages}
              canEdit={canEdit}
            />
          </Drawer>
        </Box>
      )}
    </>
  );
};

export default Languages;
